// extracted by mini-css-extract-plugin
export default {"amendInlineEditable":"fiQsv7DgwqAGrP2mHY54","active":"OZNdMZ8cM3AYOy_ytoyV"};